export const LAYOUT_SET_SIDEBAR_OPEN = 'LAYOUT_SET_SIDEBAR_OPEN'
export const LAYOUT_SET_SIDEBAR_TAB_OPEN = 'LAYOUT_SET_SIDEBAR_TAB_OPEN'
export const LAYOUT_SET_TOPBAR_TITLE = 'LAYOUT_SET_TOPBAR_TITLE'
export const LAYOUT_SET_DIALOG = 'LAYOUT_SET_DIALOG'
export const LAYOUT_ADD_ERROR = 'LAYOUT_ADD_ERROR'
export const LAYOUT_REMOVE_ERROR = 'LAYOUT_REMOVE_ERROR'
export const LAYOUT_CLEAR_ERRORS = 'LAYOUT_CLEAR_ERRORS'
export const LAYOUT_SET_LOADING_MESSAGE = 'LAYOUT_SET_LOADING_MESSAGE'
export const LAYOUT_SET_SELECTED_STATIONS = 'LAYOUT_SET_SELECTED_STATIONS'
export const LAYOUT_INIT_SELECTED_STATIONS = 'LAYOUT_INIT_SELECTED_STATIONS'
export const LAYOUT_SET_SELECTED_STATIONS_GROUP = 'LAYOUT_SET_SELECTED_STATIONS_GROUP'
export const LAYOUT_SET_PARAMS = 'LAYOUT_SET_PARAMS'
export const LAYOUT_INIT_PARAMS = 'LAYOUT_INIT_PARAMS'
export const LAYOUT_RESET_PARAMS_PAGINATION_AND_SEARCH = 'LAYOUT_RESET_PARAMS_PAGINATION_AND_SEARCH'

export const LAYOUT_ITEM_STATION_PICKER = 'LAYOUT_ITEM_STATION_PICKER'
export const LAYOUT_ITEM_OVERVIEW = 'LAYOUT_ITEM_OVERVIEW'

export const DIALOG_TYPE_DELETE = 'DIALOG_TYPE_DELETE'

export default {
  state: {
    isSidebarOpen: window.innerWidth < 1024,
    activeSidebarTab: '',
    topbarTitle: [],
    loadingMessage: null,
    dialog: null,
    errors: [],
    selectedStations: [],
    params: {},
  },
  mutations: {
    [LAYOUT_SET_SIDEBAR_OPEN](state, { open }) {
      state.isSidebarOpen = open
    },
    [LAYOUT_SET_SIDEBAR_TAB_OPEN](state, { name }) {
      state.activeSidebarTab = name
    },
    [LAYOUT_SET_TOPBAR_TITLE](state, { title }) {
      state.topbarTitle = title || []
    },
    [LAYOUT_SET_DIALOG](state, { dialog }) {
      state.dialog = dialog
    },
    [LAYOUT_ADD_ERROR](state, { error }) {
      state.errors = [error]
    },
    [LAYOUT_REMOVE_ERROR](state, { error }) {
      state.errors.splice(state.errors.indexOf(error), 1)
    },
    [LAYOUT_CLEAR_ERRORS](state) {
      state.errors = []
    },
    [LAYOUT_SET_LOADING_MESSAGE](state, { message }) {
      state.loadingMessage = message
    },
    [LAYOUT_SET_SELECTED_STATIONS](state, { stations }) {
      state.selectedStations = stations
      localStorage.setItem('selectedStations', JSON.stringify(state.selectedStations))
    },
    [LAYOUT_INIT_SELECTED_STATIONS](state, { allStations }) {
      if (localStorage.selectedStations != null) {
        state.selectedStations = JSON.parse(localStorage.selectedStations)
      } else {
        state.selectedStations = allStations
        localStorage.setItem('selectedStations', JSON.stringify(state.selectedStations))
      }
    },
    [LAYOUT_SET_SELECTED_STATIONS_GROUP](state, { group, stationIds }) {
      state.selectedStations = {
        ...state.selectedStations,
        [group]: stationIds
      }
    },
    [LAYOUT_SET_PARAMS](state, { agendaParams, agendaName }) {
      state.params = { ...state.params, [agendaName]: agendaParams }
      localStorage.setItem('params', JSON.stringify(state.params))
    },
    [LAYOUT_INIT_PARAMS](state) {
      if (localStorage.params) {
        state.params = JSON.parse(localStorage.params)
      }
    },
    [LAYOUT_RESET_PARAMS_PAGINATION_AND_SEARCH](state, { defaultParams }) {
      for (let [key, value] of Object.entries(state.params)) {
        if (value.hasOwnProperty('search')) {
          state.params[key].search = defaultParams[key].search
        }

        if (value.hasOwnProperty('searchContent')) {
          state.params[key].searchContent = defaultParams[key].searchContent
        }

        if (value.hasOwnProperty('offset')) {
          state.params[key].offset = defaultParams[key].offset
        }

        if (value.hasOwnProperty('fromTimestamp')) {
          state.params[key].fromTimestamp = defaultParams[key].fromTimestamp
        }
      }
    }
  },
  actions: {
    appShowError(context, { text, timeout = 5000 }) {
      const ref = { type: 'error', text }
      context.commit({
        type: LAYOUT_ADD_ERROR,
        error: ref
      })
      setTimeout(() => {
        context.commit({
          type: LAYOUT_REMOVE_ERROR,
          error: ref
        })
      }, timeout)
    },
    appShowErrors(context, errors) {
      errors.forEach((v, i) => {
        context.dispatch({
          type: 'appShowError',
          text: v,
          timeout: 5000 + (i * 1000)
        })
      })
    },
    appClearErrors(context) {
      context.commit(
        LAYOUT_CLEAR_ERRORS
      )
    },
    setSelectedStations(context, { stations }) {
      context.commit({
        type: LAYOUT_SET_SELECTED_STATIONS,
        stations
      })
    },
    initSelectedStations(context, allStations) {
      context.commit({
        type: LAYOUT_INIT_SELECTED_STATIONS,
        allStations
      })
    },
    setSelectedStationsGroup(context, { group, stationIds }) {
      context.commit({
        type: LAYOUT_SET_SELECTED_STATIONS_GROUP,
        group,
        stationIds
      })
    },
    setParams(context, { agendaParams, agendaName }) {
      context.commit({
        type: LAYOUT_SET_PARAMS,
        agendaParams,
        agendaName
      })
    },
    initParams(context) {
      context.commit({
        type: LAYOUT_INIT_PARAMS
      })
    },
    resetParamsPaginationAndSearch(context, defaultParams) {
      context.commit({
        type: LAYOUT_RESET_PARAMS_PAGINATION_AND_SEARCH,
        defaultParams
      })
    }
  }
}
